<template>
  <div class="nofind">
    <div>
      <div class="title">404</div>
      <h3>
        无法找到此页面，<Tooltip
          content="点击跳转首页"
          style="letter-spacing: 2px;"
          ><a href="/">{{ count }}</a></Tooltip
        >秒后跳转首页...
      </h3>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      count: 5,
      timer: null
    };
  },
  mounted() {
    this.toIndex();
  },
  methods: {
    toIndex() {
      const TIME_COUNT = 5;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 1 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            //跳转的页面写在此处
            this.$router.push({
              path: "/"
            });
          }
        }, 1000);
      }
    }
  }
};
</script>
<style scoped>
.nofind {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  letter-spacing: 20px;
  user-select: none;
}
.title {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  letter-spacing: 20px;
  user-select: none;
  font-size: 100px;
  font-weight: bolder;
}
</style>
